import { t } from "./i18n.js";
import { runtime } from "./runtime.js";
import { saveJSON } from "./storage.js";
import { KEYS } from "../../shared/schema.js";
import {
  planningProfile,
  groupForDate,
  weekDates,
  parseLocalDate,
  DAYS,
  localDateKey,
  plansForDate,
  monthDates,
} from "../../shared/planning.js";

export const profile = () => planningProfile(runtime.state.prefs);
export function planningGroups() {
  if (profile().mode === "weekly")
    return weekDates(runtime.selectedDate).map((key, index) => ({
      id: "date:" + key,
      label: t(DAYS[index]),
      detail: key,
      days: [index],
    }));
  return profile().groups.map((group) => ({
    ...group,
    label:
      group.name ||
      t(
        group.id === "Weekdays"
          ? "Mon–Fri"
          : group.id === "Weekend"
            ? "Sat–Sun"
            : "Every day",
      ),
    detail: group.days.map((index) => t(DAYS[index])).join(" · "),
  }));
}
export function planningGroup(date) {
  return groupForDate(runtime.state.prefs, date);
}
export function planTarget(date) {
  const key = localDateKey(date);
  return runtime.state.custom.planHistory?.[key]
    ? "history:" + key
    : planningGroup(date);
}
export function plansIn(group) {
  if (group.startsWith("history:"))
    return runtime.state.custom.planHistory?.[group.slice(8)] || [];
  if (group.startsWith("date:"))
    return (
      runtime.state.custom.planHistory?.[group.slice(5)] ||
      runtime.state.custom.datedPlans?.[group.slice(5)] ||
      []
    );
  return runtime.state.templates[group] || [];
}
export function mutablePlans(group) {
  if (group.startsWith("history:"))
    return ((runtime.state.custom.planHistory ||= {})[group.slice(8)] ||= []);
  if (group.startsWith("date:"))
    return (
      runtime.state.custom.planHistory?.[group.slice(5)] ||
      ((runtime.state.custom.datedPlans ||= {})[group.slice(5)] ||= [])
    );
  return (runtime.state.templates[group] ||= []);
}
export function savePlans(group) {
  const dated = group.includes(":");
  saveJSON(
    dated ? KEYS.custom : KEYS.templates,
    dated ? runtime.state.custom : runtime.state.templates,
  );
}
export function replacePlans(group, tasks) {
  if (group.startsWith("history:"))
    (runtime.state.custom.planHistory ||= {})[group.slice(8)] = tasks;
  else if (group.startsWith("date:")) {
    const key = group.slice(5);
    if (runtime.state.custom.planHistory?.[key])
      runtime.state.custom.planHistory[key] = tasks;
    else (runtime.state.custom.datedPlans ||= {})[key] = tasks;
  } else runtime.state.templates[group] = tasks;
  savePlans(group);
}
export function preservePlanHistory() {
  const now = new Date(),
    today = localDateKey(now);
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const keys = new Set([
    ...Object.keys(runtime.state.completions),
    ...monthDates(now).map(localDateKey),
    localDateKey(yesterday),
  ]);
  const history = (runtime.state.custom.planHistory ||= {});
  let changed = false;
  for (const key of keys) {
    if (key < today && !history[key]) {
      history[key] = structuredClone(
        plansForDate(runtime.state, parseLocalDate(key)),
      );
      changed = true;
    }
  }
  if (changed) saveJSON(KEYS.custom, runtime.state.custom);
}
